import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InventoryAppleItem,
  InventoryAppleState
} from '@/modules/inventory/inventoryApple/types/types.ts'

const initialState: InventoryAppleState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const inventoryAppleSlice = createSlice({
  name: 'inventoryAppless',
  initialState,
  reducers: {
    setSelected: (
      state,
      action: PayloadAction<InventoryAppleItem | undefined>
    ) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const inventoryApplesActions = inventoryAppleSlice.actions
export const { reducer: inventoryApplesReducer } = inventoryAppleSlice
